// extracted by mini-css-extract-plugin
module.exports = {"demurrage-and-detention":"DemurrageAndDetention_demurrage-and-detention__zPFod","container":"DemurrageAndDetention_container__FUWJd"};